import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider
} from '@material-ui/core'
import React, { useRef } from 'react'
import ClassificacaoRelatorio from './ClassificacaoRelatorio'
import ResumoClassificacao from './ResumoClassificacao'
import VisualizadorTotal from './VisualizadorTotal'
import { AnaliseDocumentoInfo } from './AnaliseDocumentoInfo'
import { isEmpty } from 'ramda'

import { useReactToPrint } from 'react-to-print'

import RadioErrorsViewer from './RadioErrorsViewer'

const ClassificacaoCard = ({
  entityManager,
  match,
  classificacaoManager,
  radioErrors,
  analiseDocumentos
}) => {
  const printingRef = useRef(null)
  const { classificacao } = classificacaoManager
  const handlePrint = useReactToPrint({
    content: () => printingRef.current
  })

  if (!classificacao) {
    return (
      <Paper>
        <Box
          py={2}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CircularProgress color="primary" size={50} />
        </Box>
      </Paper>
    )
  }
  return (
    <Box>
      <Grid container spacing={3} justifyContent="center">
        {classificacao.topicos.map((topico, mainIndex) => {
          return (
            <Grid item xs={12} key={topico.titulo}>
              <Paper>
                <Box p={2}>
                  <Grid container spacing={2}>
                    <Grid item xs>
                      <Typography variant="h6">
                        <Box fontWeight="fontWeightBold">{topico.titulo}</Box>
                      </Typography>
                    </Grid>
                    {mainIndex === 0 && (
                      <Grid item xs="auto">
                        <Button
                          variant="outlined"
                          size="small"
                          color="primary"
                          onClick={handlePrint}
                        >
                          Imprimir
                        </Button>
                      </Grid>
                    )}
                    {topico.itens.map((item, itemIndex) => {
                      const renderDivider = itemIndex < topico.itens.length - 1
                      return (
                        <Grid item xs={12} key={`${item.titulo}-${itemIndex}`}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <ResumoClassificacao
                                titulo={item.titulo}
                                src={item.src}
                                itens={item.status}
                                nota={item.nota}
                              />
                            </Grid>
                            {renderDivider && (
                              <Grid item xs={12}>
                                <Divider />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Box>
              </Paper>
            </Grid>
          )
        })}
        <Grid item xs={12}>
          <VisualizadorTotal
            title={`Total: ${classificacao.notaFinal} pontos`}
            status={classificacao.status}
          />
        </Grid>
        {analiseDocumentos && (
          <Grid item xs={12}>
            <AnaliseDocumentoInfo />
          </Grid>
        )}
        {!isEmpty(radioErrors) && (
          <Grid item xs={12}>
            <RadioErrorsViewer radioErrors={radioErrors} />
          </Grid>
        )}
      </Grid>
      <ClassificacaoRelatorio
        printingRef={printingRef}
        classificacao={classificacao}
        entityManager={entityManager}
        match={match}
      />
    </Box>
  )
}

export default React.memo(ClassificacaoCard)
